export const SET_EDIT_USER_ROLES_LOADED = "SET_EDIT_USER_ROLES_LOADED";

export const setEditUserRolesLoaded = (editUserRolesLoaded: boolean) => {
  return {
    editUserRolesLoaded,
    type: SET_EDIT_USER_ROLES_LOADED
  };
};
